export const INDETERMINATE = Symbol('indeterminate');
export const BRAND_ACCESS_MESSAGE = 'Please log in as a brand manager to edit this field.';
